import { createI18n } from "vue-i18n/dist/vue-i18n.esm-bundler.js";
import axios from 'axios'

export const localeQueryParam = '_locale';
export const availableLocales = {
  pl: {
    nativeName: 'Polski'
  },
  en: {
    nativeName: 'English'
  },
  ru: {
    nativeName: 'Русский'
  }
};

export function merge(...args) {

  let target = {};

  // deep merge the object into the target object
  const merger = (targ, obj) => {
    for (let prop in obj) {
      if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
        if (Object.prototype.hasOwnProperty.call(targ, prop)) {
          merger(targ[prop], obj[prop]);
        } else {
          targ[prop] = obj[prop];
        }
      } else {
        // for regular property
        targ[prop] = obj[prop];
      }
    }
  }

  // iterate through all objects and 
  // deep merge them with target
  for (let i = 0; i < args.length; i++) {
    merger(target, args[i]);
  }

  return target;
}

export async function loadDonorDictionaryMessages(locale) {
  
  let donorDictionaryMessages = await axios
    .get(`${process.env.VUE_APP_SBO_BACKEND_URL}/api/donor/dicts?language=${locale}`)
    .then((response) => {
      const donorDictionaryMapped = response.data.map(item => {
        return Object.assign({
          [locale]: {
            [item._source.domain[0]]: {
              [item._source.domain[1]]: {
                [item._source.domain[2]]: {
                  [item._source.key]: item._source.trans
                }
              }
            }
          }
        });
      });

      return merge(...donorDictionaryMapped);
    })
    .catch(err => {
      console.error(err);
    });

  return donorDictionaryMessages
}

let queryString = window.location.search;
let urlParams = new URLSearchParams(queryString);
let locale = process.env.VUE_APP_I18N_LOCALE || 'pl';
if (urlParams.has(localeQueryParam)) {
  let _locale = urlParams.get(localeQueryParam);
  if (availableLocales[_locale]) {
    locale = _locale
  } else {
    urlParams.set(localeQueryParam, process.env.VUE_APP_I18N_LOCALE)
    window.location.search = urlParams.toString()
  }
}

const i18n = createI18n({
  legacy: false,
  locale: locale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'pl',
  globalInjection: true,
  warnHtmlMessage: false,
  datetimeFormats: {
    'pl': {
      short: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }
    }
  },
  numberFormats: {
    'pl': {
      currency: {
        style: 'currency',
        currency: 'PLN'
      }
    }
  },
  messages: {[process.env.VUE_APP_I18N_FALLBACK_LOCALE]: require(`./locales/${process.env.VUE_APP_I18N_FALLBACK_LOCALE}`)},
})

export default i18n;